<template>
  <div id="app">
    <TagCloud />
  </div>
</template>

<script>
import TagCloud from "./components/TagCloud";

export default {
  name: 'App',
  components: {
    TagCloud
  }
}
</script>

<style lang="scss">
</style>
